// extracted by mini-css-extract-plugin
module.exports = {"cards":"ViewZendeskTickets_cards__1dRs5","no-entitlements":"ViewZendeskTickets_no-entitlements__1m8Ib","spinner":"ViewZendeskTickets_spinner__2wxHH"};